export default __webpack_public_path__ + "static/whitepaper_newbg-9cd26da2707ce8180b582923e6fce421.jpg";